/* eslint-disable import/named */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import { getSection } from 'gatsby-core-theme/src/helpers/getters';
import ModalContent from 'gatsby-core-theme/src/hooks/modal/modal-content';
import ModalProvider from 'gatsby-core-theme/src/hooks/modal/modalContext';
import CookieConsent from 'gatsby-core-theme/src/components/organisms/cookie-consent';
import Main from 'gatsby-core-theme/src/components/molecules/main';
import { updateAllTimezones } from 'gatsby-core-theme/src/helpers/events';
import Header from '../../molecules/header';
import Footer from '../../molecules/footer';
import Navigation from '../../organisms/navigation';
import { saveCampaign } from '../../../../helpers/rotate-links';
import { getListLang } from '../../../../helpers/getters';
import languages from '../../../../constants/languages';

function Body({
  pageContext,
  cookieConsentBody = '',
  cookieConsentBtn = '',
  siteLevelModal = false,
  SiteLevelModalProvider,
}) {
  const updatedRelation = updateAllTimezones(pageContext?.page?.relation);
  const updatedPageContext = {
    ...pageContext,
    page: { ...pageContext.page, relation: updatedRelation },
  };

  const getBodySection = (name) => getSection(name, updatedPageContext);
  const main = getBodySection('main');
  const navigation = updatedPageContext?.marketSections?.navigation || {};
  const footer = updatedPageContext?.marketSections?.footer || {};
  const template = updatedPageContext?.page?.template;
  const category = updatedPageContext?.page?.relation?.sport?.name || 'home';
  const sports = updatedPageContext?.page?.relation?.sports || null;
  saveCampaign(updatedPageContext?.page?.template);

  return (
    <>
      {navigation && (
        <Navigation
          template={template}
          section={navigation}
          category={category}
          sports={sports}
          logo={`${category === 'home' ? `logo-soccer` : `logo-${category}`}`}
          languages={getListLang(languages)}
        />
      )}
      {siteLevelModal ? (
        <SiteLevelModalProvider>
          <Header section={updatedPageContext} />
          {main && (
            <Main section={main} page={updatedPageContext?.page} pageContext={updatedPageContext} />
          )}
          <Footer section={footer} page={updatedPageContext?.page} />
        </SiteLevelModalProvider>
      ) : (
        <ModalProvider>
          <Header section={updatedPageContext} />
          {main && (
            <Main section={main} page={updatedPageContext?.page} pageContext={updatedPageContext} />
          )}
          <Footer section={footer} page={updatedPageContext?.page} />
          <ModalContent />
        </ModalProvider>
      )}

      <CookieConsent acceptText={cookieConsentBtn}>{cookieConsentBody}</CookieConsent>
      <noscript>
        <style
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: `
                .lazyload-placeholder { height: 0px!important }
              `,
          }}
        />
      </noscript>
    </>
  );
}

Body.propTypes = {
  pageContext: PropTypes.shape({
    marketSections: PropTypes.shape({
      navigation: PropTypes.shape({}),
      footer: PropTypes.shape({}),
    }),
    page: PropTypes.shape({
      id: PropTypes.number,
      type: PropTypes.string,
      path: PropTypes.string,
      template: PropTypes.string,
      relation: PropTypes.shape({}),
    }),
  }).isRequired,
};

export default Body;
